import queryString from 'query-string';
import type { NskResponse } from '~/models/Api';
import { deleteRequest, postRequest } from '~/utils/api/api_handler';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';
import type { DealEstimationHistory } from '~/models/DealEstimationHistory';

const paths = {
  create: '/vendors/deals/:deal_id/deal_estimation_histories',
  updateTypeDelete: '/vendors/deals/:deal_id/deal_estimation_histories',
  destroy: '/vendors/deals/:deal_id/deal_estimation_histories/:id',
  updateSeq: '/vendors/deals/:deal_id/deal_estimation_histories/update_seq'
};

export const create = async (
  dealEstimationHistory: DealConstructionEdit,
  dealId: number,
  dealEstimationId: number | null,
  id: number | null
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: paths.create.replace(':deal_id', String(dealId)),
      query: { deal_estimation_id: dealEstimationId, id }
    }),
    {
      dealEstimationHistory
    }
  );

export const updateTypeDelete = async (
  dealEstimationHistory: DealConstructionEdit,
  dealId: number,
  dealEstimationId: number
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: paths.create.replace(':deal_id', String(dealId)),
      query: { deal_estimation_id: dealEstimationId }
    }),
    {
      dealEstimationHistory: {
        ...dealEstimationHistory,
        operationType: 'delete'
      }
    }
  );

export const destroy = async (
  dealEstimationHistory: DealEstimationHistory,
  dealId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    paths.destroy
      .replace(':id', String(dealEstimationHistory.id))
      .replace(':deal_id', String(dealId))
  );

export const updateSeq = async (
  dealEstimationHistories: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeq.replace(':deal_id', String(dealId)), {
    dealEstimationHistories
  });
